/// <reference path="../../node_modules/@types/jquery/index.d.ts" />
/// <reference path="../../node_modules/@types/jquery-validation-unobtrusive/index.d.ts" />

import { CISAddressTypeAhead } from "./CISAddressTypeAhead";

export class EligibilityFieldBinder {

    public static Init() {
        let url: string = `${window.location.origin}/api/Eligibility/TypeaheadAddress`;
        var typeAhead = new CISAddressTypeAhead(url);
        typeAhead.Setup("EligibilityInfo_TypeaheadAddress", "EligibilityInfo_MelissaAddressKey", "EligibilityInfo_UnitNumber");

        EligibilityFieldBinder.BindHandlers();

        EligibilityFieldBinder.ShowHideCustomerLookupFields($("#EligibilityInfo_EligibilityCheckTypeId").val());

        EligibilityFieldBinder.InitValidation();
        EligibilityFieldBinder.InitEligibilityFields();
        CISAddressTypeAhead.InitTypeaheadFieldName();

        var accountNumberMask: string = $("#SiteConfigOptions_AccountNumberMask").val() as string;
        var accountPlaceholder: string = "_".repeat(accountNumberMask.length);
        if (accountNumberMask && $("#EligibilityInfo_BillingNumber").length) {
            (<any>$("#EligibilityInfo_BillingNumber")).mask(accountNumberMask, { clearIfNotMatch: true, placeholder: accountPlaceholder });
            $("#EligibilityInfo_BillingNumber").prop("maxlength", accountNumberMask.length);
        }

        var meterNumberMask: string = $("#SiteConfigOptions_MeterNumberMask").val() as string;
        var meterPlaceholder: string = "_".repeat(meterNumberMask.length);
        if (meterNumberMask && $("#EligibilityInfo_MeterNumber").length) {
            (<any>$("#EligibilityInfo_MeterNumber")).mask(meterNumberMask, { clearIfNotMatch: true, placeholder: meterPlaceholder });
            $("#EligibilityInfo_MeterNumber").prop("maxlength", meterNumberMask.length);
        }
    }

    public static BindHandlers() {
        $("#EligibilityInfo_EligibilityCheckTypeId").on("change", () => {
            EligibilityFieldBinder.ShowHideCustomerLookupFields($("#EligibilityInfo_EligibilityCheckTypeId").val());
            EligibilityFieldBinder.ResetInputs();
        });

        if ($("#continueButton").length) {
            $("#continueButton").on("click", () => {

                CISAddressTypeAhead.RevertTypeaheadFieldName("EligibilityInfo_TypeaheadAddress");

                if ($("#validate-form").valid()) {
                    $("#validate-form").trigger("submit");
                } else {
                    CISAddressTypeAhead.InitTypeaheadFieldName();
                }
            });
        }

        if ($("#validateButton").length) {
            $("#validateButton").on("click", () => {

                CISAddressTypeAhead.RevertTypeaheadFieldName("EligibilityInfo_TypeaheadAddress");

                if ($("#validate-form").valid()) {
                    $("#validate-form").trigger("submit");
                } else {
                    CISAddressTypeAhead.InitTypeaheadFieldName();
                }
            });
        }
    }

    private static InitValidation() {
        jQuery.validator.unobtrusive.parse('#validate-form');
        //var validator = $("#validate-form").validate(); // obtain validator
        $("#EligibilityInfo_ProgramClientId").rules("add", {
            required: true,
            messages: {
                required: "Required"
            },
            normalizer: (value) => {
                return $.trim(value);
            }
        });
    }

    private static InitEligibilityFields() {

        let searchStatusId: string = $("#SearchStatusId").val() as string;

        if (searchStatusId == 'Required' || searchStatusId == 'Fail') {
            $('#validateButton').prop('disabled', false);
            $("#EligibilityInfo_TypeaheadAddress").prop('disabled', false);
            $("#EligibilityInfo_TypeaheadAddress").prop('readonly', false);
            $("#EligibilityInfo_BillingNumber").prop('readonly', false);
            $("#EligibilityInfo_ZipCode").prop('readonly', false);
            $("#EligibilityInfo_MeterNumber").prop('readonly', false);
            $("#EligibilityInfo_TypeaheadAddress").val('');
        } else if (searchStatusId == 'Success' || searchStatusId == 'Warning') {
            $('#validateButton').prop('disabled', true);
            $("#EligibilityInfo_TypeaheadAddress").prop('disabled', true);
            $("#EligibilityInfo_TypeaheadAddress").prop('readonly', true);
            $("#EligibilityInfo_TypeaheadAddress").css('background-color', "");
            $("#EligibilityInfo_BillingNumber").prop('readonly', true);
            $("#EligibilityInfo_ZipCode").prop('readonly', true);
            $("#EligibilityInfo_MeterNumber").prop('readonly', true);
            $("#EligibilityInfo_TypeaheadAddress").val('@Model.TypeaheadAddress');
        } else if (searchStatusId == 'Optional') {
            $('#validateButton').prop('disabled', false);
            $("#EligibilityInfo_TypeaheadAddress").prop('disabled', false);
            $("#EligibilityInfo_TypeaheadAddress").prop('readonly', false);
            $("#EligibilityInfo_BillingNumber").prop('readonly', false);
            $("#EligibilityInfo_ZipCode").prop('readonly', false);
            $("#EligibilityInfo_MeterNumber").prop('readonly', false);
            $("#EligibilityInfo_TypeaheadAddress").val('');
        }
    }

    private static ShowHideCustomerLookupFields(lookupType) {
        $("#divBillingNumber").hide();
        $("#divMeterNumber").hide();
        $("#divZipcode").hide();
        $("#divTypeaheadAddress").hide();
        var requireZipcode = $("#EligibilityInfo_RequireZipcode").val()

        switch (lookupType) {
            case "1":
                $("#divBillingNumber").show();
                if (requireZipcode == 'True') {
                    $("#divZipcode").show();
                }

                break;
            case "2":
                $("#divMeterNumber").show();
                if (requireZipcode == 'True') {
                    $("#divZipcode").show();
                }
                break;
            case "4": $("#divTypeaheadAddress").show(); break;
        }
    }

    private static ResetInputs() {
        $("#EligibilityInfo_BillingNumber").val('');
        $("#EligibilityInfo_MeterNumber").val('');
        $("#EligibilityInfo_TypeaheadAddress").val('');
        $("#EligibilityInfo_ZipCode").val('');
        //hideSuccessDivs();
    }
}